import { createEffect, createEvent } from 'effector';

import { ParkingPass } from '@m/types/api/ParkingPass';
import { PassPlanConfiguration } from '@m/types/api/pass/SelfServiceParkingPassPlan';
import { HydratedValidationQrView } from '@m/types/api/Validation/qr/ValidationQRScan';
import { SelfServiceParkingPassService } from 'apps/customer/services/SelfServiceParkingPassService';

export const fetchPassPreview = createEffect({
  handler: SelfServiceParkingPassService.previewPassPlans,
});

export const setSelectedPlanConfig = createEvent<{ config: PassPlanConfiguration }>();

export const removeDiscount = createEvent();

export const setScannedDiscountUuid = createEvent<{ discountUuid: string }>();

export const setSuccessfulActiveVisitDiscountScan = createEvent<boolean | null>();

export const setPendingPassValidation = createEvent<HydratedValidationQrView | null | undefined>();

export const setSelectedActivePass = createEvent<ParkingPass | null | undefined>();
